const searchTypeListGeneral: string = 'search-list-general';

const searchTypeListWithFeatures: string = 'search-list-with-features';

const searchTypeGeonameId: string = 'search-geoname-id';

const searchTypeCoordinate: string = 'search-coordinate';

/*
 * Export functions.
 */
export {
    searchTypeListGeneral,
    searchTypeListWithFeatures,
    searchTypeGeonameId,
    searchTypeCoordinate,
}
